<template>
  <CModal
      :show.sync="visible"
      :close-on-backdrop="false"
  >
    <template #header>
      <h5 class="modal-title">
        <translate translate-context="email_templates.debug_logs">Send Selected Emails</translate>
      </h5>
      <CButton
          class="close"
          @click="close"
      >
        <span>&times;</span>
      </CButton>
    </template>

    <div>
      <p>
        <translate translate-context="email_templates.debug_logs" :translate-params="{count: selectedCount}">
          You are about to send %{count} email(s).
        </translate>
      </p>
      <p class="text-muted small">
        <translate translate-context="email_templates.debug_logs">
          Leave the field empty to send to the original recipients, or enter an alternative email address to send all emails to that address instead.
        </translate>
      </p>
      <CInput
          v-model="recipientAddress"
          type="email"
          :label="$pgettext('email_templates.debug_logs', 'Alternative Recipient (Optional)')"
          :placeholder="$pgettext('email_templates.debug_logs', 'e.g. test@example.com')"
      />
    </div>

    <template #footer>
      <CButton
          color="secondary"
          @click="close"
      >
        <translate translate-context="email_templates.debug_logs">Cancel</translate>
      </CButton>
      <CButton
          color="primary"
          @click="handleSend"
      >
        <CIcon name="cilPaperPlane" class="mr-2"/>
        <translate translate-context="email_templates.debug_logs">Send</translate>
      </CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'SendSelectedModal',

  props: {
    selectedCount: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      visible: false,
      recipientAddress: ''
    }
  },

  methods: {
    open() {
      this.recipientAddress = ''
      this.visible = true
    },

    close() {
      this.visible = false
    },

    handleSend() {
      const recipient = this.recipientAddress.trim() || null
      this.$emit('send', recipient)
      this.close()
    }
  }
}
</script>
